import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Injectable()
export abstract class BaseUrlService {
  private Urls: Map<string, string> = new Map<string, string>();

  constructor(private _configService: ConfigService) { }

  protected addUrls(urls: Map<string, string>): void {
    urls.forEach((val, key) => {
      this.Urls.set(key, `${val}`);
    });
  }

  public getUrl(key: string, ...urlPart: Array<string>): string {
    const possibleHosts = this._configService.settings.brandingByHost;
    // console.log('theme: window.location: ', window.location)
    // console.log('theme: possibleHosts: ', possibleHosts)
    const host = window.location.hostname?.toLowerCase();
    let hostConfig;
    if (possibleHosts?.[host]) {
      hostConfig = possibleHosts[host];
    }

    // console.log('hostConfig: ', hostConfig)
    const apiUrl = this._configService.settings
      ? (hostConfig?.apiUrl
        ? hostConfig?.apiUrl
        : this._configService.settings.apiUrl)
      : '';

    // console.log('apiUrl: ', apiUrl)
    let baseUrl = this.Urls.get(key);
    if (!baseUrl) throw new Error(`O endpoint ${key} não foi encontrado.`);

    if (urlPart && urlPart.length) {
      urlPart.forEach((str, ix) => {
        // baseUrl = baseUrl.replace('{' + ix + '}', str);
        baseUrl = baseUrl + '/' + str;
      });
    }

    return `${apiUrl}/${baseUrl}`;
  }
}
